import React from "react";
import { StaticGoogleMap } from "react-static-google-map";
import { Gcp } from "../../types/gcp";
import { Resource } from "../../types/resource";
import { Site } from "../../types/site";
import HeavyMachineMarker from "./HeavyMachineMarker";
import SiteRectangle from "./SiteRectangle";
type Props = {
  gcp: Gcp;
  resource: Resource;
  sites: [Site];
  width: number;
};

const Map: React.FC<Props> = ({ gcp, resource, sites, width }) => {
  // MEMO: scaleは1or2しか指定できない。このため地図の最大サイズは実質1280pxとなる
  const scale = width > 640 ? 2 : 1;
  const mapWidth = Math.floor(width / scale);

  return (
    <>
      <div className="row">
        <div className="col-12 text-center">
          {resource?.lat && resource?.lon ? (
            <StaticGoogleMap
              size={`${mapWidth}x${mapWidth}`}
              scale={scale}
              center={`${resource.lat},${resource.lon}`}
              zoom={14}
              apiKey={gcp.apiKey}
            >
              <HeavyMachineMarker resource={resource} />
              {sites.map((site) => (
                <SiteRectangle site={site} key={`site-${site.id}`} />
              ))}
            </StaticGoogleMap>
          ) : (
            <p>位置情報を取得できていません</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Map;
